import React, { useState, useEffect } from 'react';
import fetchSearchResults from './Utils/FetchSearchTabsResult';
import './GlobalSearch.css';
import PageProfileModal from '../PopupPages/PageProfile';

const GlobalSearch = () => {
  const [query, setQuery] = useState('');
  const [allResults, setAllResults] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [renderOperation, setRenderOperation] = useState(null);

  useEffect(() => {
    fetchSearchResults().then(setAllResults);
  }, []);

  useEffect(() => {
    if (query.trim()) {
      const matches = allResults.filter(item =>
        item.name.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredResults(matches);
      setShowPopup(matches.length > 0);
    } else {
      setFilteredResults([]);
      setShowPopup(false);
    }
  }, [query, allResults]);

  const handleUserClick = (operationType, item) => {
    setShowPopup(false);
    setQuery('');

    // Navigate to /<profile-name>-profile for profile types
    if (item.type === 'profile' && operationType === 'page') {
      const profileSlug = item.name.toLowerCase().replace(/\s+/g, '-');
      window.location.href = `http://kleido.ai/${profileSlug}-profile`;
      return;
    }

    // Handle user-type operations
    setRenderOperation({
      operationType,
      data: { userId: item.id },
    });
  };

  const handleCloseModal = () => {
    setRenderOperation(null);
  };

  return (
    <div className="gs-searchbar">
      <input
        type="text"
        placeholder="Search keyword..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        className="search-input"
      />

      {showPopup && (
        <div className="search-popup">
          {filteredResults.map(item => (
            <div key={item.id} className="search-result">
              <div style={{display: "flex", flexDirection: "row"}}>
                <div style={{width: 150}}>
                  <span>{item.name} </span>
                </div>
                <div style={{width: 150}}>
                  {/* Common "View Page" action */}
                  <button onClick={() => handleUserClick("page", item)} className="src-option-btn">🔍</button>

                  {/* User-specific actions */}
                  {item.type === "user" && (
                    <>
                      {item.canMessage && (
                        <button onClick={() => handleUserClick("messaging", item)} className="src-option-btn">💬</button>
                      )}
                      {item.canAudioCall && (
                        <button onClick={() => handleUserClick("audio", item)} className="src-option-btn">📞</button>
                      )}
                      {item.canVideoCall && (
                        <button onClick={() => handleUserClick("video", item)} className="src-option-btn">  
                          <i className="fas fa-video"></i>
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Render modal for user interactions */}
      {['page', 'messaging', 'audio', 'video'].includes(renderOperation?.operationType) && renderOperation?.data && (
        <PageProfileModal
          userId={renderOperation.data.userId}
          operationType={renderOperation.operationType}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default GlobalSearch;
